module.exports = __webpack_public_path__ + "img/cd2b44d.jpg";